import { SiteToValueRatioChartUnwrapped } from '../../../components/SiteValueCharts/SiteToValueRatioChart.tsx';
import { Tkv2SiteValueChartsParams } from '../../referenceView/utils/useTkv2SiteValueChartsParams.ts';
import { IMAGE_FACTOR, PNG_HEIGHT, PNG_WIDTH } from './constants.ts';
import { pngChartMaker } from '../../../components/graphs/pngChartMaker.tsx';

export const pngSiteToValueRatioChartMaker = async (
  siteValueChartParams: Tkv2SiteValueChartsParams,
): Promise<string | undefined> => {
  const { siteToValueRatioChartData, publicRecordsIsLoading } = siteValueChartParams;

  if (!siteToValueRatioChartData) {
    return undefined;
  }

  return pngChartMaker(SiteToValueRatioChartUnwrapped, {
    data: siteToValueRatioChartData,
    isLoading: publicRecordsIsLoading,
    disableAnimations: true,
    width: PNG_WIDTH * IMAGE_FACTOR,
    height: PNG_HEIGHT * IMAGE_FACTOR,
  });
};
